export default function TopActionButtons(props: any) {
	// inject row data to click handler
	const clickHandlerWrapper = () => {
		const data = props.getSelectedRowData();
		return props.clickHandler(data);
	};
	return <button onClick={clickHandlerWrapper}>{props.name}</button>;
}
